var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputDiv',{attrs:{"placeholder":_vm.placeholder},on:{"submit":function($event){return _vm.addOption()}},model:{value:(_vm.newPollText),callback:function ($$v) {_vm.newPollText=$$v},expression:"newPollText"}})}
var staticRenderFns = []

export { render, staticRenderFns }